module.exports = __webpack_public_path__ + "p4_img3.jpg?c5e4c11519bb5920f8736eb379ed0fbc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img3.jpg
// module id = 122
// module chunks = 0